import { useQuery } from '@tanstack/react-query';

import { useCodeGenController } from '../../CodeGen/Hooks/useCodeGenController';
import { contextDesignerQueryKeys } from '../ContextDesignerQueryKeys';
import { ContextDesignerCodeSnapshotModel } from './useContextDesignerSnapshot';

export const contextCodeArtifactsQueryKey = contextDesignerQueryKeys.codeArtifacts;

export function useContextCodeArtifacts(contextId: string, initialSnapshot?: ContextDesignerCodeSnapshotModel | null) {
	const {
		getContextDomainCodeFiles,
		getContextApplicationCodeFiles,
		getContextTestCodeFiles,
		getCodeBaseDomainInfo,
		getCodeBaseApplicationInfo,
		getCodeBaseTestInfo,
	} = useCodeGenController(contextId);

	return useQuery({
		queryKey: contextCodeArtifactsQueryKey(contextId),
		queryFn: async (): Promise<ContextDesignerCodeSnapshotModel> => {
			const [domainFiles, applicationFiles, testFiles, domainCodeBase, applicationCodeBase, testCodeBase] = await Promise.all([
				getContextDomainCodeFiles(contextId),
				getContextApplicationCodeFiles(contextId),
				getContextTestCodeFiles(contextId),
				getCodeBaseDomainInfo(contextId),
				getCodeBaseApplicationInfo(contextId),
				getCodeBaseTestInfo(contextId).catch(() => null),
			]);

			return {
				domainFiles: domainFiles ?? [],
				applicationFiles: applicationFiles ?? [],
				testFiles: testFiles ?? [],
				domainCodeBase: domainCodeBase ?? null,
				applicationCodeBase: applicationCodeBase ?? null,
				testCodeBase: testCodeBase ?? null,
			};
		},
		enabled: Boolean(contextId),
		initialData: initialSnapshot ?? undefined,
		staleTime: 10000,
		refetchOnWindowFocus: false,
	});
}
